import { createSelector } from 'reselect'

export const getUserRoles = (state, props) => state.kanbo.userRoles[props.userId]

export const getAllUsersRolesConfig = (state, props) => state.kanbo.config.allUsersRoles

export default createSelector(
  [
    getUserRoles,
    getAllUsersRolesConfig,
  ],
  (
    userRoles,
    allUsersRolesConfig,
  ) => ({
    userRoles,
    allUsersRolesConfig,
  })
)
